"use server";

import { listPublishedLocations } from "@/features/academy-locations/queries";
import { suggestPlaces as suggest } from "@/features/places/search";

/** The location search's suggestions as the visitor types: stored towns and postcode districts only. */
export async function suggestPlaces(typed: string) {
  return suggest(String(typed).slice(0, 80));
}

/** The registration form's proposed locations, slug => "DAS Bury · Bury Interchange", by name. */
export async function locationOptions() {
  const locations = await listPublishedLocations();
  return locations
    .map((location) => ({
      slug: location.slug,
      label: `${location.name} · ${location.siteName}`,
    }))
    .sort((a, b) => a.label.localeCompare(b.label));
}
